<template>
  <div class="container-fluid m-0 p-0 test">
    <div class="modal fade" tabindex="-1" id="modal_create_vessel">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Edit Info</h5>
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-3">
                <h6 class="font-weight-bold">General Info</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <label class="float-left" for="vessel_name"
                  >Vessel Name</label
                  >
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      id="vessel_name"
                      v-model="newVessel.vessel_name"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="vessel_code"
                  >Vessel Code</label
                  >
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="vessel_code"
                      id="vessel_code"
                      v-model="newVessel.code"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="vessel_type"
                  >Vessel Type</label
                  >
                  <select
                      class="form-control form-control-sm"
                      id="vessel_type"
                      v-model="newVessel.vessel_type_id"
                  >
                    <option value="''">-- Select Vessel Type --</option>
                    <option
                        v-for="vesselTypeKey in vesselTypeKeys"
                        :key="vesselTypeKey.id"
                        :value="vesselTypeKey.id"
                    >{{ vesselTypeKey.name }}
                    </option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="float-left" for="vessel_group"
                  >Vessel Group</label
                  >
                  <select
                      class="form-control form-control-sm"
                      id="group"
                      v-model="newVessel.vessel_group_id"
                  >
                    <option value="''">-- Select Vessel Group --</option>
                    <option
                        v-for="vesselGroupKey in vesselGroupKeys"
                        :key="vesselGroupKey.id"
                        :value="vesselGroupKey.id"
                    >{{ vesselGroupKey.name }}
                    </option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="float-left" for="registry_port"
                  >Registry Port</label
                  >
                  <select
                      class="form-control form-control-sm"
                      id="registry_port"
                      v-model="newVessel.registry_port_id"
                  >
                    <option value="''">-- Select Registry Port --</option>
                    <option
                        v-for="portKey in portKeys"
                        :key="portKey.id"
                        :value="portKey.id"
                    >{{ portKey.name }}
                    </option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="float-left" for="flag">Flag</label>
                  <select
                      class="form-control form-control-sm"
                      id="flag"
                      v-model="newVessel.flag_id"
                  >
                    <option value="''">-- Select Flag --</option>
                    <option
                        v-for="countryKey in countryKeys"
                        :key="countryKey.id"
                        :value="countryKey.id"
                    >{{ countryKey.name }}
                    </option
                    >
                  </select>
                </div>
                <div class="form-group">
                  <label class="float-left" for="imo_no">IMO No.</label>
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="imo_no"
                      id="imo_no"
                      v-model="newVessel.imo_no"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="official_no"
                  >Official No.</label
                  >
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="official_no"
                      id="official_no"
                      v-model="newVessel.official_no"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="insurance">Insurance</label>
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="insurance"
                      id="insurance"
                      v-model="newVessel.insurance"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="japan_coastal"
                  >Japan Coastal</label
                  >
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="japan_coastal"
                      id="japan_coastal"
                      v-model="newVessel.japan_coastal"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="cba_type">CBA Type</label>
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="cba_type"
                      id="cba_type"
                      v-model="newVessel.cba_type"
                  />
                </div>
                <div class="form-group">
                  <label class="float-left" for="poea_principal"
                  >POEA Principal</label
                  >
                  <input
                      type="text"
                      class="form-control form-control-sm"
                      name="poea_principal"
                      id="poea_principal"
                      v-model="newVessel.poea_principal"
                  />
                </div>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-3 font-weight-bold">
                <h6>Assigned Manning</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <div v-for="manningKey in manningKeys" :key="manningKey.id">
                    <div class="form-check d-flex">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          :value="manningKey.id"
                          :id="'manningKey' + manningKey.id"
                          v-model="newVessel.manning"
                      />
                      <label
                          class="form-check-label"
                          :for="'manningKey' + manningKey.id"
                      >
                        {{ manningKey.alias }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr/>
            <div class="row">
              <div class="col-3 font-weight-bold">
                <h6>ECDIS Type</h6>
              </div>
              <div class="col-9">
                <div class="form-group">
                  <div v-for="ecdisKey in ecdisKeys" :key="ecdisKey.id">
                    <div class="form-check d-flex">
                      <input
                          class="form-check-input"
                          type="checkbox"
                          :value="ecdisKey.id"
                          v-model="newVessel.ecdis_type"
                          :id="'ecdisKey' + ecdisKey.id"
                      />
                      <label
                          class="form-check-label"
                          :for="'ecdisKey' + ecdisKey.id"
                      >
                        {{ ecdisKey.name }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <div class="row bg-light text-left border-top border-bottom py-2">
      <div class="col-sm-12 px-0 h-100 my-auto">
        <!--                <master-list-side-nav-toggle></master-list-side-nav-toggle>-->
        <span class="mx-3 font-weight-bold lead">Vessel Master List</span>

        <span class="mx-3">
          <router-link
              class="btn btn-sm btn-outline-primary font-weight-bolder"
              title="Add New Vessel Record"
              v-if="isSystemAdmin"
              :to="{name:'AddVessel'}">
            <span class="fas fa-user-plus"></span>
            Add Vessel
          </router-link>
        </span>

        <span class="float-right py-1 mx-2">
          <button
              class="btn btn-xs btn-outline-secondary px-2 mr-1"
              disabled
              title="Print Crew Result"
          >
            <span class="fas fa-print"></span>
            Print
          </button>

          <button
              class="btn btn-xs btn-outline-secondary px-2 mr-1"
              disabled
              title="Print Crew Result"
          >
            <span class="fas fa-mail-bulk"></span>
            Email
          </button>

          <button
              class="btn btn-xs btn-outline-secondary px-2 mr-1"
              disabled
              title="Print Crew Result"
          >
            <span class="fas fa-file-excel"></span>
            Export
          </button>

          <button
              class="btn btn-xs btn-outline-secondary px-2 mr-1"
              title="Print Crew Result"
              @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>
    <div class="row text-small py-3s">
      <div class="col col-3 mt-4">
        <!--        <small class="float-left align-bottom">{{-->
        <!--          `${pagination.from} to ${pagination.to} of ${pagination.total}`-->
        <!--        }}</small>-->

        <small class="float-left align-bottom" v-if="pagination.from == null">{{ `No Records found` }}</small>
        <small class="float-left align-bottom" v-else>{{
            `${pagination.from} to ${pagination.to} of ${pagination.total}`
          }}</small>
      </div>

      <div class="col col-3">
        <div class="form-group form-row text-right form-inline mb-0">
          <label
              class="col col-3 font-weight-bolder col-form-label form-label-xs text-right"
              for="search-value"
          >
            Search:
          </label>

          <div class="col col-6 text-left">
            <input type="text" id="search-value" class="form-control form-control-xs"
                   placeholder="Search Vessel Name"
                   v-model="searchValue"
                   @input="searchVessel"
            >
          </div>
        </div>
      </div>

      <div class="col col-3" v-if="isPrincipal && !isKline">
        <div class="form-group form-row text-right form-inline mb-0">
          <label
              class="col col-3 font-weight-bolder col-form-label form-label-xs text-right"
              for="manning"
          >
            Manning:
          </label>

          <div class="col col-6 text-left">
            <select
                id="manning"
                required
                class="form-control form-control-xs"
                v-model="manning"
                @change="searchVessel"
            >
              <option :value="0">--- ALL MANNING ---</option>
              <option
                  :value="manningKey.id"
                  v-for="manningKey in manningKeys"
                  :key="manningKey.id"
              >{{ manningKey.alias }}
              </option
              >
            </select>
          </div>
        </div>
      </div>

      <div class="col col-3">
        <div class="form-group form-row text-right form-inline mb-0">
          <label
              class="col col-4 font-weight-bolder col-form-label form-label-xs text-right"
              for="status"
          >
            Vessel Status:
          </label>

          <div class="col col-6 text-left">
            <select
                id="status"
                required
                class="form-control form-control-xs"
                v-model="active"
                @change="setStatus"
            >
              <option :value="1">ACTIVE</option>
              <option :value="0">INACTIVE</option>
              <option :value="''">--- ALL STATUSES ---</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-12">
        <table class="table table-sm table-hover table-bordered">
          <thead class="table-secondary">
          <tr>
            <th class="p-1" scope="col">#</th>
            <th class="p-1" scope="col">NAME</th>
            <th class="p-1" scope="col">CODE</th>
            <th class="p-1" scope="col">TYPE</th>
            <th class="p-1" scope="col">GROUP</th>
            <th class="p-1" scope="col">COMPANY</th>
            <th class="p-1" scope="col">REGISTRY PORT</th>
            <th class="p-1" scope="col">FLAG</th>
            <th class="p-1" scope="col">IMO NO.</th>
            <th class="p-1" scope="col">OFFICIAL NO.</th>
            <th class="p-1" scope="col">STATUS</th>
            <th class="p-1" scope="col">ACTION</th>
          </tr>
          </thead>
          <tbody class="text-smaller">
          <tr v-for="(vessel, index) in vessels" :key="vessel.id">
            <th scope="row" class="p-1 align-middle text-right">
              {{ (index + pagination.from) }}
            </th>
            <td class="align-middle text-left">
              <span v-if="vessel">{{ vessel.name }}</span>
            </td>
            <td class="p-1 align-middle text-left">{{ vessel.code }}</td>
            <td class="align-middle p-1 text-left">
              {{ vessel.type }}
              <!--                <span v-if="vessel.vessel_type">{{-->
              <!--                  vessel.vessel_type.name-->
              <!--                }}</span>-->
            </td>
            <td class="p-1 align-middle text-left">
              {{ vessel.groupName }}
              <!--                {{ vessel.vessel_group ? vessel.vessel_group.name : "&#45;&#45;&#45;&#45;&#45;&#45;" }}-->
            </td>
            <td class="p-1 align-middle text-left">KRBS</td>
            <td class="p-1 align-middle text-left" :title="vessel.portName">
              {{ vessel.portCode }}
              <!--                {{ vessel.port ? vessel.port.code : "&#45;&#45;&#45;&#45;&#45;&#45;" }}-->
            </td>
            <td class="p-1 align-middle text-left" :title="vessel.flagName">
              {{ vessel.flagCode }}
              <!--                {{ vessel.flag ? vessel.flag.code : "&#45;&#45;&#45;&#45;&#45;&#45;" }}-->
            </td>
            <td class="p-1 align-middle text-left">{{ vessel.imo_no }}</td>
            <td class="p-1 align-middle text-left">
              {{ vessel.official_no }}
            </td>
            <td class="p-1 align-middle">{{ vessel.active | status }}</td>
            <td>
              <button
                  class="btn btn-xs btn-outline-primary px-2 mr-1"
                  title="Print Vessel Result"
                  @click="viewVessel(vessel.id)"
              >
                <i class="fas fa-eye"></i>
                View
              </button>

              <button
                  class="btn btn-xs btn-outline-danger px-2 mr-1"
                  title="Delete Vessel Result"
                  @click="confirmDeleteVessel(vessel.id)"
                  v-if="isSystemAdmin"
              >
                <i class="fas fa-trash"></i>
                Delete
              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <nav aria-label="...">
          <ul class="pagination text-smallest">
            <li
                class="page-item"
                :class="{ disabled: pagination.currentPage === 1 }"
            >
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li
                v-for="page in paginationPages"
                :key="page"
                class="page-item"
                :class="{
                disabled: page === '...',
                active: page === pagination.currentPage,
              }"
            >
              <button class="page-link" @click="setPage(page)">
                {{ page }}
              </button>
            </li>

            <li
                class="page-item"
                :class="{
                disabled: pagination.currentPage === pagination.lastPage,
              }">
              <button class="page-link" @click="setPage(pagination.lastPage)">
                Last
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapGetters, mapActions} from "vuex";

export default {
  name: "VesselIndex",
  mixins: [vueAppMixin, gateMixin],

  data() {
    return {
      newVessel: {
        vessel_name: null,
        code: null,
        vessel_type_id: null,
        vessel_group_id: null,
        registry_port_id: null,
        flag_id: null,
        imo_no: null,
        official_no: null,
        insurance: null,
        japan_coastal: null,
        cba_type: null,
        poea_principal: null,
        manning: [],
        ecdis_type: [],
      },
      searchKey: "all",
      searchValue: "",
      manning: 0,
      rank: 0,
      natl: 0,
      active: 1,
      mannings: [],
    };
  },

  methods: {
    ...mapActions([
      "getVesselTypeKeys",
      "getVesselGroupKeys",
      "getPortKeys",
      "getCountryKeys",
      "updateVesselInfo",
      "getManningKeys",
      "getEcdisKeys",
      "getVessels",
      "deleteVessel",
    ]),

    viewVessel(vesselId) {
      this.$router.push({
        name: "VesselGeneralInfo",
        params: {id: vesselId},
      });
    },

    setStatus(e) {
      this.active = e.target.value;
      this.pagination.currentPage = 0;
      this.searchVessel();
    },

    searchVessel() {
      let page = this.pagination.currentPage;

      let params = {
        page: page,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        manning: this.manning,
        // active: this.active,
      };
      if (this.active !== '') params['active'] = this.active;
      this.getVessels(params);
    },

    async setPage(page) {
      this.pagination.currentPage = page;
      await this.searchVessel();
    },

    async initializeData() {
      await this.searchVessel();
      await this.getManningKeys();

      await this.getVesselTypeKeys();
      await this.getVesselGroupKeys();
      await this.getPortKeys();
      await this.getCountryKeys();
      await this.getEcdisKeys();
    },

    async confirmDeleteVessel(vesselId) {
      if (await this.confirmDeleteAlert()) {
        let params = {
          id: vesselId,
        };
        let deletedVessel = await this.deleteVessel(params);
        if (deletedVessel) {
          this.successAlert("Vessel Successfully Deleted!!", "DELETE");
        }
      }
    },
  },

  computed: {
    ...mapGetters([
      "vessels",
      "pagination",
      "manningKeys",
      "vesselTypeKeys",
      "vesselGroupKeys",
      "portKeys",
      "countryKeys",
      "ecdisKeys",
    ]),

    paginationPages() {
      let pages = [];
      let currentPage = this.pagination.currentPage;
      let lastPage = this.pagination.lastPage;
      if (lastPage > 1) {
        let initialLimit = 1;
        if (currentPage + 5 > lastPage) {
          initialLimit = lastPage - 10;
        } else if (currentPage > 6) {
          initialLimit = currentPage - 5;
        }
        initialLimit = initialLimit < 1 ? 1 : initialLimit;
        for (let i = initialLimit; i <= initialLimit + 10; i++) {
          pages.push(i);
          if (i >= lastPage) {
            break;
          }
        }
      }
      return pages;
    },
  },

  async created() {
    // this.onGoing('Vessel Index', 'PENDING');
    // this.getVessels();
    await this.initializeData();
  },
};
</script>

<style scoped></style>
